import { take, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../../../providers/services/catalog.service";
import * as i2 from "../../../providers/services/seo.service";
import * as i3 from "../products.module";
export class ProductResolverService {
    constructor(catalogService, seoService) {
        this.catalogService = catalogService;
        this.seoService = seoService;
        this.setSeo = ({ body: { data: { product, links } } }) => {
            this.seoService.setTags(product.name, product.description_seo, product.image_header.path, links);
        };
    }
    resolve(route, state) {
        return this.catalogService.getProduct(route.params.slug).pipe(take(1), tap(this.setSeo));
    }
}
ProductResolverService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProductResolverService_Factory() { return new ProductResolverService(i0.ɵɵinject(i1.CatalogService), i0.ɵɵinject(i2.SeoService)); }, token: ProductResolverService, providedIn: i3.ProductsModule });
